import gql from 'graphql-tag';

export const ACCEPT_MUTATION = gql`
  mutation AcceptDropInClinicRequest($requestId: String!, $prepResponsibility: String) {
    acceptDropInClinicRequest(requestId: $requestId, prepResponsibility: $prepResponsibility) {
      eventId
      patientId
    }
  }
`;

export const ACCEPT_FOR_MUTATION = gql`
  mutation AcceptDropInClinicRequestFor($requestId: String!, $providerId: String!) {
    staff_acceptDropInClinicRequestFor(requestId: $requestId, providerId: $providerId) {
      status
    }
  }
`;

export const REMOVE_MUTATION = gql`
  mutation RemoveDropInClinicRequest($requestId: String!) {
    removeDropInClinicRequest(requestId: $requestId) {
      status
    }
  }
`;

export const PREPARING_MUTATION = gql`
  mutation PreparingDropInClinicRequest($requestId: String!) {
    prepareDropInClinicRequest(requestId: $requestId) {
      eventId
      prepEventId
    }
  }
`;

export const COMPLETE_PREP_MUTATION = gql`
  mutation CompletePrepDropInClinicRequest($requestId: String!) {
    completePrepDropInClinicRequest(requestId: $requestId) {
      status
    }
  }
`;

export const FIX_ZOMBIE_REQUEST_MUTATION = gql`
  mutation FixZombieDropInClinicRequest($requestId: String!) {
    fixZombieDropInClinicRequest(requestId: $requestId) {
      status
    }
  }
`;

export const AVAILABILITY_QUERY = gql`
  query GetStateProviderAvailability($date: DateTime) {
    getClinicAvailabilitiesByDate(date: $date) {
      state
      providerAvailability {
        dropInProvider {
          firstName
          lastName
        }
        availability {
          start
          end
        }
      }
      overview {
        windows {
          start
          end
        }
        hasAvailability
      }
    }
  }
`;
